import React from "react";
import RppProductConfig from './RPPProductConfig'
import CustomiseHeader from './../../customisation/customiseHeader'

export default class ProductPackageConfiguration extends React.Component{

  constructor(props) {
    super(props);

    if(this.props.onSelectingUser !== undefined){
      this.onSelectingUser = this.props.onSelectingUser.bind(this);
    }
    if(this.props.onSelectingAddons !== undefined){
      this.onSelectingAddons = this.props.onSelectingAddons.bind(this);
    }
    if(this.props.onSelectingGeography !== undefined){
      this.onSelectingGeography = this.props.onSelectingGeography.bind(this);
    }
  }

  render(props){
    let configuration = this.props.productPackageDefaultConfig?.configuration
    let productPackageConfig = (this.props.productPackageConfig &&
    this.props.productPackageConfig.industries[configuration.industry]) ? this.props.productPackageConfig.industries[configuration.industry].packages[configuration.package] : null
    return (
      <div>
        <CustomiseHeader />
        <RppProductConfig
          productPackageConfig = {productPackageConfig}
          productPackageDefaultConfig = {this.props.productPackageDefaultConfig}
          onSelectingUser = {this.onSelectingUser}
          onSelectingAddons = {this.onSelectingAddons}
          onSelectingGeography = {this.onSelectingGeography}
          coupon = {this.props.coupon}
        />
      </div>
    )
  }
}
